import api from './api';

export const postCheckUsername = username =>
  api.post('/api/v1/users/checkusername', { username })